module.exports = __webpack_public_path__ + "e045a6db8c374e59e4d5d88c74da6803.jpg";